import ApiService from '../services/apiService';

export const indexCompanyAnnouncementsRequest = ({ dispatch, params, callback, successCallback }) =>
  ApiService.request('get', '/company_announcements', {
    dispatch,
    params,
    callback,
    successCallback
  });

export const showCompanyAnnouncementRequest = (id, { dispatch, successCallback }) =>
  ApiService.request('get', `/company_announcements/${id}`, {
    dispatch,
    successCallback
  });

export const createCompanyAnnouncementRequest = ({
  dispatch,
  params,
  formData,
  failureCallback,
  successCallback,
  callback
}) =>
  ApiService.request('post', `/company_announcements`, {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback,
    callback
  });

export const updateCompanyAnnouncementRequest = (
  id,
  { dispatch, params, formData, failureCallback, successCallback, callback }
) =>
  ApiService.request('put', `/company_announcements/${id}`, {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback,
    callback
  });

export const deleteCompanyAnnouncementRequest = (id, { dispatch, failureCallback, successCallback, callback }) =>
  ApiService.request('delete', `/company_announcements/${id}`, {
    dispatch,
    failureCallback,
    successCallback,
    callback
  });

export const notifyCompanyAnnouncementRequest = (
  id,
  { dispatch, params, callback, successCallback, failureCallback }
) =>
  ApiService.request('post', `/company_announcements/${id}/notify`, {
    dispatch,
    params,
    callback,
    successCallback,
    failureCallback
  });
